<div class="p-2">
  <div *ngIf="isLoadingFiles" class="p-4">
    <app-loading-indicator [medium]="true" [message]="'Retrieving files'"></app-loading-indicator>
  </div>
  <div *ngIf="!isLoadingFiles" class="">
    <div *ngIf="errorRetrievingFiles; else noFilesRetrieveError" class="text-danger text-center py-4">
      <strong>{{errorMessage}}</strong>
    </div>
    <ng-template #noFilesRetrieveError>
      <div class="">
        <div class="row justify-content-center">
          <div class="col-12 col-md-8 col-lg-6 col-xl-5">
            <app-file-upload [storageType]="'well'" [wellID]="wellID" (fileUploadSucceeded)="wellFileUploadHandler($event)"></app-file-upload>
          </div>
        </div>
      </div>
      <div *ngIf="!wellFiles || wellFiles.length == 0; else wellFilesArePresent" class="text-center py-4">
        <div><span><i class="far fa-images fa-3x"></i></span></div>
        <p class="mb-0">No well files have been uploaded yet.</p>
        <p>Upload images, documents, or other files related to this well.</p>
      </div>
      <ng-template #wellFilesArePresent>
        <div class="present-well-files d-flex justify-content-end align-items-center">
          <div class="rr-w-100 rr-w-md-50 input-group input-group-sm">
            <input class="form-control" style="font-size: 0.9em" type="text" trim="blur" name="filesQuery" [(ngModel)]="filesQuery" placeholder="Filter by file name or description...">
          </div>
          <div class="d-flex align-items-center pl-2">
            <div class="btn-group">
              <button class="btn btn-sm" [class.btn-outline-dark]="tableDisplay" [class.btn-dark]="!tableDisplay" (click)="swapViews(false)" title="Gallery view"><i class="fas fa-th-large pr-2"></i>Cards</button>
              <button class="btn btn-sm" [class.btn-outline-dark]="!tableDisplay" [class.btn-dark]="tableDisplay" (click)="swapViews(true)" title="Table view"><i class="fas fa-bars pr-2"></i>Table</button>
            </div>
          </div>
        </div>
        <div *ngIf="!tableDisplay" class="row">
          <div *ngFor="let file of wellFiles | classFilter : filesQuery : searchableProps; index as i" class="col-sm-12 col-md-6 col-lg-4 py-2">
            <app-file-view-edit [file]="file" [disableImgPreview]="true" [storageType]="'well'" [tableDisplay]="false" [wellID]="wellID" (fileUpdateSucceeded)="wellFileUpdatedHandler($event)" (fileDeleteSucceeded)="wellFileDeletedHandler($event)"></app-file-view-edit>
          </div>
          <div *ngIf="(wellFiles | classFilter : filesQuery : searchableProps)?.length == 0;" class="col-12 text-center py-4">
            <p><em>No files matching "{{filesQuery}}" found</em></p>
          </div>
        </div>
        <div *ngIf="tableDisplay" class="mt-2 mb-4">
          <div class="rr-elevation-z2 table-responsive">
            <table class="table table-hover rr-table">
              <thead class="rr-table-heder">
                <tr>
                  <th>Description <span class="pl-2 pointer-cursor" title="Sort"><i class="fas fa-sort" (click)="sortListBy('description')"></i></span></th>
                  <th>File Name <span class="pl-2 pointer-cursor" title="Sort"><i class="fas fa-sort" (click)="sortListBy('fileName')"></i></span></th>
                  <th class="text-nowrap">Size <span class="pl-2 pointer-cursor" title="Sort"><i class="fas fa-sort" (click)="sortListBy('size')"></i></span></th>
                  <th>Added <span class="pl-2 pointer-cursor" title="Sort"><i class="fas fa-sort" (click)="sortListBy('createdOn')"></i></span></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let file of wellFiles | classFilter : filesQuery : searchableProps; index as i" class="blue-hover-bg">
                  <td><strong>{{file.description}}</strong></td>
                  <td>{{file.fileName}}</td>
                  <td class="text-nowrap">{{file.size | fileSize }}</td>
                  <td>{{file.createdOn | date:'shortDate'}}</td>
                  <td><app-file-view-edit [file]="file" [disableImgPreview]="true" [storageType]="'well'" [tableDisplay]="true" [wellID]="wellID" (fileUpdateSucceeded)="wellFileUpdatedHandler($event)" (fileDeleteSucceeded)="wellFileDeletedHandler($event)"></app-file-view-edit></td>
                </tr>
                <tr *ngIf="(wellFiles | classFilter : filesQuery : searchableProps)?.length == 0;" class="text-center ignore-hover">
                  <td colspan="5"><em>No files matching "{{filesQuery}}" found</em></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>
